<template>
  <div class="product-detail-page">
    <!-- 顶部导航 -->
    <!-- <AppHeader /> -->
    <!-- Banner 区域 -->
    <section class="detail-banner">
      <div class="banner-overlay"></div>
      <div class="container">
        <div class="banner-content">
          <h1>校园视频公话</h1>
          <p class="subtitle">让思念看得见，让沟通更安全</p>
          <p class="desc">转为校园场景打造的智慧视频通话解决方案</p>
         <button class="btn-primary" @click="contactUs">
           <span class="btn-text">合作咨询</span> 
           <span class="divider">|</span> 
           <span class="btn-text">020-82038386</span>
         </button>
        </div>
      </div>
    </section>

    <!-- 核心功能 -->
 <section class="core-features">
  <div class="container">
    <div class="section-title">
      <h2>核心功能</h2>
      <p>科技守护沟通，智慧连接校园与家庭</p>
    </div>
    <div class="features-grid">
      <div class="feature-item" v-for="feature in features" :key="feature.id">
        <div class="feature-icon-wrapper">
          <img class="feature-iconlarge" :src="feature.icon" loading="lazy" alt="">
        </div>
        <h4>{{ feature.title }}</h4>
        <p>{{ feature.desc }}</p>
      </div>
    </div>
  </div>
</section>

 <!-- 视频电话终端 -->
    <section class="device-intro">
      <div class="container">
        <div class="section-header">
          <h2>视频电话终端</h2>
          <p class="sub-text">专为校园场景设计，稳定耐用，操作简单</p>
        </div>
        
        <div class="intro-content">
          <!-- <div class="intro-text">
            <ul class="feature-list">
              <li v-for="item in deviceFeatures" :key="item.id">
                <div class="feature-icon">
                    <img class="feature-icon" src="../assets/images/headphone-icon.png" loading="lazy" alt="">
                  
                </div>
                <div class="feature-content">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.desc }}</p>
                </div>
              </li>
            </ul>
          </div> -->
          <div class="intro-text">
            <ul class="feature-list">
              <li v-for="item in deviceFeatures" :key="item.id">
                <div class="feature-icon">
                  <img class="feature-icon" :src="item.icon" loading="lazy" alt="">
                </div>
                <div class="feature-content">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.desc }}</p>
                </div>
              </li>
            </ul>
          </div>
          
          <div class="intro-image">
            <!-- 引入设备图片 -->
            <div class="image-wrapper">
              <img src="../assets/images/video-phone-device.png" loading="lazy" alt="视频电话终端" class="device-img">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 安全管理体系 -->
    <section class="security-system">
      <div class="container">
        <div class="section-title">
          <h2>安全管理体系</h2>
          <p>多重保障机制，守护每一次通话安全</p>
        </div>
        <div class="security-grid">
          <div class="security-item" v-for="item in securityItems" :key="item.id">
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 应用场景 -->
   <!-- 应用场景 -->
<section class="scenarios">
  <div class="container">
    <div class="section-title">
      <h2>灵活部署 全校覆盖</h2>
      <p class="subtitle">根据学校规模与场景需求，提供多样化部署方案，快速落地，稳定运行。</p>
    </div>
    
    <div class="scenarios-grid">
      <div class="scenario-item" v-for="item in scenarios" :key="item.id">
        <div class="scenario-img-box">
          <img :src="item.icon" :alt="item.title">
        </div>
        <div class="scenario-content">
          <h4>{{ item.title }}</h4>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

    <!-- 底部 -->
    <AppFooter />

    <!-- 返回按钮（固定） -->
    <!-- <button class="back-btn" @click="goBack">← 返回</button> -->
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'ProductDetail',
  components: {
    // AppHeader,
    AppFooter
  },
  data() {
    return {
   features: [
  {
    id: 1,
    title: '人脸识别登录',
    desc: '学生通过人脸识别快速登录，精准匹配通讯录，沟通更安全',
    icon: require('@/assets/images/face-login-icon.png') // 人脸识别图标
  },
  {
    id: 2,
    title: '高清亲情通话',
    desc: '高清画质与清晰音质，还原真实通话体验，拉近亲情距离',
    icon: require('@/assets/images/video-call-icon.png') // 视频通话图标
  },
  {
    id: 3,
    title: '家校互动管理',
    desc: '家长与学校双端互联，通话记录可查，家校沟通更透明',
    icon: require('@/assets/images/school-home-icon.png') // 家校互动图标
  },
  {
    id: 4,
    title: '通话限时管理',
    desc: '灵活设置通话时长与时段，避免影响学习与生活秩序',
    icon: require('@/assets/images/time-limit-icon.png') // 时间管理图标
  },
  {
    id: 5,
    title: '安全管控保障',
    desc: '敏感内容智能过滤，守护校园安全',
    icon: require('@/assets/images/security-icon.png') // 安全图标
  }
],
      deviceFeatures: [
  {
    id: 1,
    title: '10.1英寸高清触摸屏',
    desc: '高灵敏触控，操作流畅，显示清晰。',
    icon: require('../assets/images/screen-icon.png')
  },
  {
    id: 2,
    title: '人脸识别摄像头',
    desc: '活体检测，识别精准，安全可靠。',
    icon: require('../assets/images/face-icon.png')
  },
  {
    id: 3,
    title: '高保真音频',
    desc: '降噪麦克风与高品质扬声器，通话更清晰。',
    icon: require('../assets/images/headaudio-icon.png')
  },
  {
    id: 4,
    title: '工业设计',
    desc: '防尘防水，抗冲击，适应校园复杂环境。',
    icon: require('../assets/images/shield-icon.png')
  },
  {
    id: 5,
    title: '多种安装方式',
    desc: '壁挂式/嵌入式安装，灵活适配不同场景。',
    icon: require('../assets/images/install-icon.png')
  }
],
      securityItems: [
        {
          id: 1,
          title: '通话时段管理',
          desc: '灵活设置通话使用时段，避免影响学习与休息。'
        },
        {
          id: 2,
          title: '通话时长限制',
          desc: '灵活设置单次与每月通话时长，合理控制使用。'
        },
        {
          id: 3,
          title: '数据安全加密',
          desc: '通话数据加密传输存储，保障隐私安全。'
        },
        {
          id: 4,
          title: '敏感词过滤',
          desc: '智能识别通话过程敏感词，自动拦截。'
        }
      ],
    scenarios: [
  { 
    id: 1, 
    title: '宿舍区', 
    desc: '学生宿舍公共区域部署，方便学生与家长定期联系。',
    icon: require('@/assets/images/scene-university.png') // 请替换为实际宿舍图片路径
  },
  { 
    id: 2, 
    title: '教学楼/走廊', 
    desc: '教学楼公共区域部署，课间或休息时间便捷通话。',
    icon: require('@/assets/images/scene-public.png') // 请替换为实际走廊图片路径
  },
  { 
    id: 3, 
    title: '公共区域', 
    desc: '活动中心、服务中心等，提供更人性化沟通服务。',
    icon: require('@/assets/images/scene-school.png') // 请替换为实际公共区域图片路径
  },
  { 
    id: 4, 
    title: '户外区域', 
    desc: '防水防尘设计，适应操场、活动区等户外环境。',
    icon: require('@/assets/images/scene-enterprise.png') // 请替换为实际户外图片路径
  }
]

    }
  },
  methods: {
    goBack() {
      this.$emit('back-to-home')
    },
    contactUs() {
      alert('联系电话：020-82038386')
    }
  }
}
</script>

<style scoped>
.product-detail-page {
  min-height: 100vh;
}

/* Banner */
.detail-banner {
  position: relative;
  height: 750px;
  /* 引入背景图片 - 替换为您的实际图片路径 */
  background-image: url('../assets/images/video-phone-banner.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  
}

.detail-banner .container {
  position: relative;
  z-index: 2;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.banner-content {
  max-width: 600px;
  color: #fff;
}

.banner-content h1 {
  font-size: 56px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: bold;
  line-height: 1.2;
}

.subtitle {
  /* font-size: 24px; */
  color: #fff;
  margin-bottom: 15px;
  font-weight: 500;
}

.desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 40px;
  line-height: 1.6;
}

.btn-primary {
  background: #11b1f1;
  color: #fff;
  border: none;
  padding: 14px 32px;
  border-radius: 24px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
  
  /* Flex 布局 */
  display: inline-flex;
  align-items: center; /* 垂直居中 */
  justify-content: center;
  gap: 8px;
  line-height: 1; /* 关键：消除默认行高带来的偏移 */
}

.btn-primary:hover {
  background: #1557b0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
}

/* 统一文字样式 */
.btn-text {
  display: inline-block;
  line-height: 1;
}

.divider {
  opacity: 0.6;
  margin: 0 2px; /* 稍微缩小间距，让整体更紧凑 */
  font-weight: normal;
}
/* 核心功能 */
/* 核心功能 */
.core-features {
  padding: 80px 0;
  background: #f0f4f8;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 32px;
  color: #1e293b;
  margin-bottom: 12px;
  font-weight: bold;
}

.section-title p {
  color: #64748b;
  font-size: 16px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.feature-item {
  text-align: center;
  padding: 40px 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

/* 图标外层虚线边框容器 */
.feature-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: 2px dashed #cbd5e1; */
  border-radius: 8px;
  background: #fff;
}

.feature-iconlarge {
  width: 70px;
  height: 70px;
  object-fit: contain;
}

.feature-item h4 {
  font-size: 18px;
  margin-bottom: 12px;
  color: #1e293b;
  font-weight: 600;
  text-align: center;
}

.feature-item p {
  font-size: 15px;
  color: #64748b;
  line-height: 1.6;
  text-align: center;
  margin: 0;
}

/* 响应式 */
@media (max-width: 1200px) {
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
}

/* 设备介绍 */
.device-intro {
  padding: 60px 0;
  background: #fff;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-header h2 {
  font-size: 28px;
  color: #1e293b;
  margin-bottom: 10px;
  font-weight: bold;
}

.sub-text {
  color: #64748b;
  font-size: 16px;
}

.intro-content {
  display: flex;
  gap: 40px; /* 减小间距 */
  align-items: flex-start;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px; /* 添加左右内边距 */
}

.intro-text {
  flex: 1.2; /* 左侧占更多空间 */
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px; /* 减小间距 */
  gap: 15px; /* 减小图标和内容间距 */
}

.feature-icon {
  flex-shrink: 0;
  width: 38px; /* 减小图标 */
  height: 38px;
  color: #1a73e8;
  margin-top: 3px;
}


.feature-content {
  flex: 1;
}

.feature-content h4 {
  font-size: 18px; /* 稍微减小字号 */
  margin-bottom: 5px;
  color: #1e293b;
  font-weight: 600;
}

.feature-content p {
  font-size: 15px; /* 稍微减小字号 */
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

.intro-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-wrapper {
  position: relative;
  /* border: 1px dashed #cbd5e1; */
  border-radius: 8px;
  /* padding: 30px; */
  /* background: #f8fafc; */
  max-width: 320px; /* 限制最大宽度 */
}

.device-img {
  width: 100%;
  max-width: 420px; /* 限制图片最大宽度 */
  height: auto;
  display: block;
  border-radius: 4px;
}

/* 响应式 */
@media (max-width: 992px) {
  .intro-content {
    flex-direction: column;
    gap: 40px;
    padding: 0 20px;
  }
  
  .image-wrapper {
    max-width: 100%;
  }
  
  .device-img {
    max-width: 100%;
  }
}

/* 安全体系 */
.security-system {
  padding: 80px 0;
  background: #f8fafc;
}

.security-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  max-width: 1400px;
  margin: 0 auto;
}

.security-item {
  text-align: center;
  padding: 30px 20px;
}

.security-item h4 {
  color: #2399d5;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
}

.security-item p {
  font-size: 15px;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

/* 响应式 */
@media (max-width: 992px) {
  .intro-content {
    flex-direction: column;
    gap: 40px;
  }
  
  .security-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .security-grid {
    grid-template-columns: 1fr;
  }
  
  .feature-list li {
    flex-direction: column;
    gap: 10px;
  }
}

/* 应用场景 */
/* 应用场景 */
.scenarios {
  padding: 80px 0;
  background: #fff; /* 整体背景白色 */
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 标题区域 */
.section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 32px;
  color: #1a2b3c; /* 深蓝黑色标题 */
  margin-bottom: 12px;
  font-weight: bold;
  letter-spacing: 1px;
}

.section-title .subtitle {
  font-size: 16px;
  color: #667788; /* 灰色副标题 */
  margin: 0;
}

/* Grid 布局 */
.scenarios-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

/* 卡片整体 */
.scenario-item {
  background: #f0f5fa; /* 浅蓝灰色背景，还原图片质感 */
  border-radius: 8px;
  overflow: hidden; /* 确保图片圆角不溢出 */
  display: flex;
  flex-direction: column;
  transition: transform 0.3s;
}

.scenario-item:hover {
  transform: translateY(-5px); /* 可选：增加悬停效果 */
}

/* 图片区域 */
.scenario-img-box {
  width: 100%;
  height: 180px; /* 固定图片高度 */
  background: #e2e8f0;
}

.scenario-img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保证图片填满且不变形 */
  display: block;
}

/* 文字内容区域 */
.scenario-content {
  padding: 20px 15px;
  text-align: center;
}

.scenario-content h4 {
  font-size: 18px;
  color: #1a2b3c;
  margin: 0 0 10px 0;
  font-weight: bold;
}

.scenario-content p {
  font-size: 15px;
  color: #556677;
  margin: 0;
  line-height: 1.6;
}

/* 响应式适配 */
@media (max-width: 992px) {
  .scenarios-grid {
    grid-template-columns: repeat(2, 1fr); /* 平板变2列 */
  }
}

@media (max-width: 576px) {
  .scenarios-grid {
    grid-template-columns: 1fr; /* 手机变1列 */
  }
  
  .scenario-img-box {
    height: 200px;
  }
}

/* 返回按钮 */
.back-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #1a73e8;
  color: #fff;
  border: none;
  padding: 15px 30px;
  border-radius: 30px;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 5px 20px rgba(26, 115, 232, 0.4);
  transition: all 0.3s;
  z-index: 1000;
}

.back-btn:hover {
  background: #1557b0;
  transform: translateY(-2px);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 响应式 */
@media (max-width: 768px) {
  .features-grid,
  .security-grid,
  .scenarios-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .detail-banner .container,
  .intro-content {
    flex-direction: column;
  }
}
</style>